import { connect } from 'react-redux';
import { login } from '../../../actions/auth/actionCreators';
import LoginForm from './LoginForm';


const mapStateToProps = (state) => ({
  isLoading: state.auth.loginRequest,
  errorMessage: state.auth.loginError
});

const mapDispatchToProps = (dispatch) => ({
  onSubmit: (email, password, keepSignedIn) => dispatch(login(email, password, keepSignedIn)),
});

const LoginFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(LoginForm);

export default LoginFormContainer;



// WEBPACK FOOTER //
// src/components/login/LoginForm/LoginFormContainer.js